/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function HardSkillsIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-hard-skills">
        <g id="Group 66 Copy 2">
          <g id="Group 65 Copy 2">
            <g id="Group 63 Copy 2">
              <g id="Group 61 Copy 2">
                <g id="Group 59 Copy 3">
                  <g id="icon-legal and finance copy">
                    <g id="Group 58 Copy 2">
                      <g id="icon-journey-course">
                        <circle
                          id="Oval"
                          cx="78.5"
                          cy="78.5"
                          r="77.5"
                          fill={mainColor}
                          stroke="white"
                          stroke-width="2"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="tag copy">
          <path
            id="Shape"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M72.3217 117.815C69.4435 120.728 64.7715 120.728 61.8934 117.815L38.1586 93.8089C35.2805 90.8955 35.2805 86.1661 38.1586 83.2527L73.879 47.114C75.8701 45.0786 78.5905 43.9611 81.4292 44.001L102.818 44.3004C107.194 44.3602 110.723 47.9322 110.782 52.3622V52.4221C111.768 52.7813 112.773 53.1604 113.779 53.5795C119.239 55.8743 124.049 58.9674 127.361 62.3198L127.538 62.4994C132.881 68.007 132.289 72.1976 131.461 74.1931C130.633 76.2085 128.11 79.581 120.501 79.6209C117.426 79.6408 113.936 79.102 110.349 78.0843C109.836 79.4014 109.047 80.6386 108.022 81.6762L72.3217 117.815ZM97.3922 56.7916C95.0146 54.4028 91.1633 54.4028 88.7857 56.7916C86.4081 59.1804 86.4081 63.0498 88.766 65.4188C91.1436 67.8076 94.995 67.8076 97.3726 65.4188C97.4119 65.3695 97.4561 65.3201 97.5003 65.2708C97.5445 65.2214 97.5887 65.1721 97.628 65.1227C100.045 66.9192 103.032 68.5776 106.215 69.92C117.101 74.4804 124.273 73.059 124.941 71.4599C125.157 70.9466 124.882 69.2685 122.328 66.6429L122.21 66.5244C119.518 63.8197 115.332 61.1743 110.675 59.2199C110.587 59.1804 110.503 59.1458 110.42 59.1113C110.336 59.0767 110.253 59.0422 110.165 59.0027L110.282 67.6102C109.3 67.2746 108.278 66.8798 107.217 66.4454C104.23 65.2017 101.44 63.6618 99.1018 62.0035C99.3769 60.1675 98.807 58.213 97.3922 56.7916Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}

HardSkillsIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
HardSkillsIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(HardSkillsIcon);
memoized.displayName = 'HardSkillsIcon';
export default memoized;
